import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * ScrollySlide
 *  - The slider component displayed at the bottom right corner of Scrollables
 */
export function ScrollySlider(props) {
  return (
    <div>
      <div className="scrolly-slider">
        <p className="scrolly-slider__label">{props.slideValue}</p>
        <SliderInput value={props.slideValue} onChange={props.onChange} />
        {props.slideValue}
      </div>
    </div>
  );
}

ScrollySlider.propTypes = {
  /**
   * Numerical value displayed for SliderValue
   */
  slideValue: PropTypes.number.isRequired,
  /**
   * Callback function to be executed when SliderValue changes
   */
  onChange: PropTypes.func.isRequired,
};

ScrollySlider.defaultProps = {
  slideValue: 4.5,
};

/**
 * SliderInput
 *  - Input tag of type range, provides a slider component.
 */
function SliderInput(props) {
  return (
    <input
      id={props.id}
      type="range"
      min={props.min}
      max={props.max}
      value={props.value}
      onChange={props.onChange}
      step={props.step}
    />
  );
}

SliderInput.propTypes = {
  /**
   * The id attribute to be set for input
   */
  id: PropTypes.string,
  /**
   * The lower range for the slider
   */
  min: PropTypes.number.isRequired,
  /**
   * The higher range for the slider
   */
  max: PropTypes.number.isRequired,
  /**
   * Current slider value
   */
  value: PropTypes.number.isRequired,
  /**
   * Callback function to be executed when sliderValue changes
   */
  onChange: PropTypes.func.isRequired,
  /**
   * The step value by which the slider changes.
   */
  step: PropTypes.number.isRequired,
};

SliderInput.defaultProps = {
  id: "typeinp",
  min: 0,
  max: 10,
  value: 0,
  step: 0.5,
};
